var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-date-time"},[_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm._f("toFormattedDate2")(_vm.gameDateTime,'d-MMM-yyyy - HH:mm')))]),_vm._v(" HRS ")])}
var staticRenderFns = []

export { render, staticRenderFns }